import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Link from "next/link";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Typography, Avatar, Box, Grid } from "@mui/material";
import logo from "../../assets/landing/Banner-logo.svg";
import Image from "next/image";
import style from "../../styles/registation.module.css";
import * as constants from "../../Components/constants";
import { useState } from "react";
import ForgetPass from "../../Components/ForgetPass";
import Registration from "../../Components/Registration/Registration";
import { NextSeo } from "next-seo";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link
        style={{ textDecoration: "none" }}
        color="inherit"
        href="https://researchrider.com/"
      >
        www.researchrider.com
      </Link>
    </Typography>
  );
}

const theme = createTheme();
const baseURL = constants.BASE_URL;

export default function Registation() {
  //Forget Pass Modal
  const [showB, setShowB] = useState(false);
  const toggleShowB = () => setShowB(!showB);

  //Token Check Function

  React.useEffect(() => {
    if (localStorage.auth_token) {
      fetch(`${baseURL}/user/token-check`, {
        mode: "cors",
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: localStorage.getItem("auth_token"),
        }),
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => console.log(error));
    } else {
    }
  });

  // Login function end

  return (
    <ThemeProvider theme={theme}>
      <NextSeo
        title="Join ResearchRider for free"
        description="Be connected with the worldwide research hub."
        canonical="https://www.researchrider.com/user/registration"
        openGraph={{
          url: "https://www.researchrider.com/user/registration",
          title: "Research Rider | Log In",
          description: "Be connected with the worldwide research hub.",
          siteName: "Research Rider",
        }}
      />

      <Grid
        container
        component="main"
        sx={{ height: "100vh" }}
        className={style.main_box}
      >
        <CssBaseline />
        <Grid
          item
          className={`${style.mobile_view}`}
          sm={4}
          md={8}
          style={{
            background:
              "linear-gradient(311.76deg, #0073ff -15.24%, #292065 78.85%)",
          }}
        >
          <Box
            xs="false"
            sx={{
              xs: false,
              my: 18,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div className={`${style.rr_logo}`}>
              <Image
                src={logo}
                layout="fill"
                sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
                alt="research rider logo"
                title="research rider logo"
                priority
              />
            </div>
            <span
              style={{ marginTop: "-10px" }}
              className="text-white fw-bold fs-2"
            >
              Grow up Being a Researcher
            </span>
          </Box>
        </Grid>

        <Grid item xs={12} sm={8} md={4}>
          <Box
            className={`${style.signup_box}`}
            sx={{
              my: 2,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar sx={{ bgcolor: "info.main" }}>
              <HowToRegIcon />
            </Avatar>
            <Typography component="h4" variant="h6">
              Sign up
            </Typography>
          </Box>

          <Box
            sx={{
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Registration />

            <Grid container sx={{ cursor: "pointer" }}>
              <Grid item xs>
                <a style={{ textDecoration: "none" }} onClick={toggleShowB}>
                  Forgot password?
                </a>
              </Grid>
              <Grid item>
                <small>
                  Already on Research Rider?{" "}
                  <Link href="/user/login">Log in</Link>
                </small>
              </Grid>
            </Grid>
          </Box>

          <Copyright sx={{ my: 4 }} />
        </Grid>
      </Grid>
      <>
        <ForgetPass
          toggleShowB={() => toggleShowB()}
          showB={showB}
          setShowB={setShowB}
        />
      </>
    </ThemeProvider>
  );
}
